import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import { connect } from 'react-redux';
import { Builder } from './columnBuilder';
import { sortByUserName, sortByEndDateThenName, sortByClientThenEnd } from '../../../../utilities/sortJobExt';

import { workerTable, workerLink } from './_common';

class ExpirationsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: 0,
            sortDesc: false,
            workers: []
        };
        this.changeSort = this.changeSort.bind(this);
        this.sortOnly = this.sortOnly.bind(this);
    }

    componentDidMount() {
        const { workers } = this.props;
        this.sortOnly(workers, sortByEndDateThenName);
    }

    UNSAFE_componentWillReceiveProps(props) {
        const { workers } = props;
        const { sortDesc } = this.state;

        this.sortOnly(workers, sortByEndDateThenName, sortDesc);
    }

    changeSort(comparer, columnIndex) {
        if (!comparer) {
            return;
        }
        let { sortColumn, sortDesc, workers } = this.state;

        if (columnIndex === sortColumn) {
            sortDesc = !sortDesc;
            this.setState({ sortDesc });
        } else {
            sortColumn = columnIndex;
            sortDesc = false;
            this.setState({ sortColumn, sortDesc });
        }
        this.sortOnly(workers, comparer, sortDesc);
    }

    sortOnly(workers, comparer, sortDesc = false) {
        if (!comparer) {
            return;
        }
        const sortFunc = sortDesc ? (a, b) => comparer(b, a, true) : comparer;
        const sorted = [...workers.sort(sortFunc)];
        this.setState({ workers: sorted });
    }

    getColumn3(tenant) {
        switch (tenant) {
            case 'admin':
                return { builder: Builder.client, label: messages.client, sort: sortByClientThenEnd };
            case 'client':
            default:
                return { builder: Builder.title, label: messages.assignment };
        }
    }

    render() {
        const { history, tenant, projectsOptions, users, inviteUser } = this.props;
        const { workers } = this.state;
        if (!workers) return null;
        const noneMessage = <FormattedMessage id={'noExpiringContracts'} defaultMessage={'No workers expiring in next 30 days.'} />;

        let columnDefinition = worker => (
            <div className="row">
                {Builder.endDate(worker, 'col-xs-2 clickable-row hidden-xs ellipsis', () => workerLink(worker, history))}
                {Builder.name(worker, 'col-sm-4 col-xs-7 ellipsis clickable-row ellipsis', () => workerLink(worker, history))}
                {this.getColumn3(tenant).builder(worker, 'col-xs-3 hidden-xs ellipsis status', () => workerLink(worker, history))}
                {Builder.extend(worker, tenant, 'col-sm-3 col-xs-4 extend-button pull-right', projectsOptions, users, inviteUser)}
            </div>
        );

        let headings = [
            { text: <FormattedMessage {...messages.expirationDate} />, size: 'col-xs-2 clickable-row ellipsis hidden-xs', sort: sortByEndDateThenName },
            { text: <FormattedMessage {...messages.worker} />, size: 'col-sm-4 col-xs-7 ellipsis', sort: sortByUserName },
            { text: <FormattedMessage {...this.getColumn3(tenant).label} />, size: 'col-xs-3 hidden-xs ellipsis status', sort: this.getColumn3(tenant).sort },
            { size: 'col-xs-4 col-sm-3 col-lg-2' }
        ];

        const { sortColumn, sortDesc } = this.state;
        return workerTable(messages.workerExpirations, workers, columnDefinition, headings, this.changeSort, sortColumn, sortDesc, noneMessage);
    }
}

ExpirationsList.defaultProps = {
    workers: undefined,
    tenant: 'client'
};
ExpirationsList.propTypes = {
    workers: PropTypes.array.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, null)(ExpirationsList);



// WEBPACK FOOTER //
// ./src/pages/dashboard/components/workers/expirations.jsx